import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useWindowSize} from "../../../../hook/useWindowSize";
import {useMySearchParams} from "../../../../hook/useMySearchParams";
import SearchBox from "../../../components/general/searchBox";
import {useGetMedicationItems} from "../../../../hook/request/medication";
import Icon from "../../../components/general/icon";
import MedicationItemCardsBox from "../../../components/basicInformation/medication/dataList/medicationItemCardsBox";
import MedicationItemsTable from "../../../components/basicInformation/medication/dataList/medicationItemsTable";
import Pagination from "../../../components/general/table/pagination";
import {ROUTES} from "../../../../constants";
import DeleteMedicationItemModal from "../../../components/basicInformation/medication/deleteMedicationItemModal";
import {useFindAccessInAccessList} from "../../../../constants/constant/accessProcess";

const dataListTitles = [
  "نام دارو",
  "توضیحات",
  "دسته بندی",
  "مکسا",
]

type TFilterValues = {
  pageNumber?: string;
  perPage?: string;
  search?: string;
}


const MedicationItemsList = () => {

  const [width] = useWindowSize();
  const {findAccessInAccessList} = useFindAccessInAccessList();
  const [searchParams] = useSearchParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();
  const [medicationItemsData, setMedicationItemsData] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    pageNumber: "0",
    perPage: "10",
    search: "",
  });

  // services
  const getMedicationItemsRequest = useGetMedicationItems(getQueryParams(filterValues));

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || "",
    }
    setFilterValues(_filterValues)
  }, [searchParams]);


  useEffect(() => {
    getMedicationItemsRequest?.data?.data?.result &&
    setMedicationItemsData(getMedicationItemsRequest?.data?.data.result)
  }, [getMedicationItemsRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    updateSearchParams({
      pageNumber: "0",
      perPage: filterValues?.perPage,
      [name]: value,
    })
  }

  const doChangePage = (param: any) => {
    updateSearchParams({
      pageNumber: param?.index,
      perPage: filterValues?.perPage,
    })
  }

  return (
    <>
      <div className="card-box">
        <section className="filter-box d-flex flex-column flex-md-row mb-4">
          <div className="form-group ms-md-auto">
            <SearchBox
              name="search"
              value={filterValues?.search}
              onChange={handleFilterChange}
              placeholder="جستجوی دارو"
            />
          </div>
          {
            findAccessInAccessList('BASIC_MEDICATION') &&
            <div className="d-flex align-items-center align-items-stretch justify-content-center justify-content-md-start mb-3 m-md-0">
              <Link to={ROUTES.MEDICATION_ADD.PATH} className="btn btn-primary rounded d-flex align-items-center fw-bold px-4">
                <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="add-square"/></span>
                افزودن دارو
              </Link>
            </div>
          }
        </section>

        <section className="table-cont table-responsive">
          {
            width < 900 ?
              <MedicationItemCardsBox
                dataList={medicationItemsData}
                dataListTitles={dataListTitles}
                isRequesting={getMedicationItemsRequest.isPending}
              /> :
              <MedicationItemsTable
                dataList={medicationItemsData}
                dataListTitles={dataListTitles}
                isRequesting={getMedicationItemsRequest.isPending}
              />
          }
          <Pagination
            paginationData={{...filterValues, ...medicationItemsData}}
            doChangePage={doChangePage}
          />
        </section>
      </div>
      <DeleteMedicationItemModal/>
    </>
  );
};

export default MedicationItemsList;